export type LoginMethod = "google" | "facebook" | "apple" | "email" | "magic";

const STORAGE_KEY = "venturu_last_login_method";

export function setLastLoginMethod(method: LoginMethod) {
  try {
    localStorage.setItem(STORAGE_KEY, method);
  } catch {
    // localStorage may be unavailable (private browsing, SSR, etc.)
  }
}

export function getLastLoginMethod(): LoginMethod | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (
      value === "google" ||
      value === "facebook" ||
      value === "apple" ||
      value === "email" ||
      value === "magic"
    ) {
      return value;
    }
    return null;
  } catch {
    return null;
  }
}

export function getOAuthProviderUrl(provider: string): string | null {
  switch (provider) {
    case "google":
      return "/api/oauth/google";
    case "facebook":
      return "/api/oauth/facebook";
    case "apple":
      return "/api/oauth/apple";
    default:
      return null;
  }
}
